import { render, staticRenderFns } from "./polar-area.vue?vue&type=template&id=3dcb2b7c&"
import script from "./polar-area.vue?vue&type=script&lang=js&"
export * from "./polar-area.vue?vue&type=script&lang=js&"
import style0 from "./polar-area.vue?vue&type=style&index=0&id=3dcb2b7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports